"use client"

import React from 'react';
import Paths from "@/components/Paths/Paths";
import styles from "./PathsList.module.css";
import {Skeleton} from "@mui/material";
import usePathsData from "@/utils/hooks/usePathsData";

export default function PathsList() {
  const data = usePathsData()

  const divs = [];
  for (let i = 0; i < 10; i++) {
    divs.push(<div key={i} className={styles.skeletonInner}>
      <Skeleton variant="rounded" animation={"pulse"} width={'100px'} height={100}/>
      <Skeleton variant="rectangular" animation={"pulse"} width={'calc(100% - 100px)'} height={20}/>
    </div>);
  }

  return (
    <>
      {!data && <div className={styles.skeleton}>{divs}</div>}
      {data && <Paths data={data}/>}
    </>
  )
}
